export const publishablePlatforms = ['xiaohongshu', 'douyin', 'wechat', 'kuaishou']

export const publicationStatusLabels = {
  available: '可排期',
  scheduled: '待发布',
  published: '已发布',
  failed: '发布失败',
}

export const assetLifecycleStatusLabels = {
  available: '未排期',
  partiallyScheduled: '部分已排期',
  scheduled: '已排期待发布',
  partiallyPublished: '部分已发布',
  published: '全部已发布',
  failed: '发布异常',
}

export const planStatusLabels = {
  pending: '待发布',
  next: '待发布',
  published: '已发布',
  canceled: '已取消',
  failed: '发布失败',
}

export function normalizeTemplatePlatforms(platforms) {
  return [...new Set((Array.isArray(platforms) ? platforms : []).filter(platform => publishablePlatforms.includes(platform)))]
}

export function getPublicationId(assetId, platform) {
  return `asset-publication-${assetId}-${platform}`
}

export function normalizePlanStatus(status) {
  return ['next', 'published', 'canceled', 'failed'].includes(status) ? status : 'pending'
}

export function isActivePlanStatus(status) {
  return ['pending', 'next'].includes(normalizePlanStatus(status))
}

export function publicationStatusFromPlan(status) {
  const normalized = normalizePlanStatus(status)
  if (normalized === 'published') return 'published'
  if (normalized === 'canceled') return 'canceled'
  if (normalized === 'failed') return 'failed'
  return 'scheduled'
}

export function createPublicationMap(publications) {
  return new Map(publications.map(publication => [`${publication.assetId}:${publication.platform}`, publication]))
}

export function getAssetPlatformStates(asset, template, publicationMap) {
  return normalizeTemplatePlatforms(template?.platforms).map(platform => {
    const publication = publicationMap.get(`${asset.id}:${platform}`)
    return {
      platform,
      status: publication?.status === 'published' ? 'published' : publication?.status === 'scheduled' ? 'scheduled' : publication?.status === 'failed' ? 'failed' : 'available',
      publication,
    }
  })
}

export function getAssetLifecycleStatus(platformStates) {
  const statuses = platformStates.map(state => state.status)
  if (!statuses.length || statuses.every(status => status === 'available')) return 'available'
  if (statuses.includes('failed')) return 'failed'
  if (statuses.every(status => status === 'published')) return 'published'
  if (statuses.includes('published')) return 'partiallyPublished'
  if (statuses.every(status => status === 'scheduled')) return 'scheduled'
  if (statuses.includes('scheduled')) return 'partiallyScheduled'
  return 'available'
}
